import React, { useEffect, useState } from "react";
import { Spinner } from "@masterteam/mt-design-react";

import Header from "./Header";
import Charts from "./Charts";
import ObjectivesList from "./ObjectivesList";

import api from "../../providers/api";
import { addToast } from "../../helpers";

import "./style.scss";

const KPIsDashboard = () => {
  const [data, setData] = useState([]);
  const [strategies, setStrategies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(true);
  const [KPIsStatuses, setKPIsStatuses] = useState([]);
  const [selectedStrategy, setSelectedStrategy] = useState(null);

  const getStrategies = async () => {
    setIsLoading(true);
    try {
      const res = await api.strategy.getAllWithPerspectives();

      setStrategies(res.Data);
      setSelectedStrategy(res.Data?.[0]);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getData = async () => {
    setDataLoading(true);
    try {
      const res = await api.kpiDashboard.getDataByStrategyId(
        selectedStrategy?.ID
      );

      setData(res.Data);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    } finally {
      setDataLoading(false);
    }
  };

  const getKPIStatuses = async () => {
    try {
      const res = await api.handshake.getStatuses();
      setKPIsStatuses(res?.Data);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    }
  };

  useEffect(() => {
    getKPIStatuses();
    getStrategies();
  }, []);

  useEffect(() => {
    if (selectedStrategy) getData();
  }, [selectedStrategy]);

  return (
    <div className="kpis-dashboard">
      <Header
        strategies={strategies}
        isLoading={isLoading}
        kpiStatuses={KPIsStatuses}
        selectedStrategy={selectedStrategy}
        setSelectedStrategy={setSelectedStrategy}
      />
      {dataLoading ? (
        <div className="loder-container" style={{ marginTop: "32px" }}>
          <Spinner size="large" />
        </div>
      ) : (
        <>
          <Charts
            isLoading={dataLoading}
            data={data}
            selectedStrategy={selectedStrategy}
            kpisStatuses={KPIsStatuses}
          />
          <ObjectivesList
            selectedStrategy={selectedStrategy}
            statuses={KPIsStatuses}
          />
        </>
      )}
    </div>
  );
};

export default KPIsDashboard;
